import { render, staticRenderFns } from "./HeaderSimples.vue?vue&type=template&id=5ed4b807&scoped=true&"
import script from "./HeaderSimples.vue?vue&type=script&lang=js&"
export * from "./HeaderSimples.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSimples.vue?vue&type=style&index=0&id=5ed4b807&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed4b807",
  null
  
)

export default component.exports